const AnalysisTemplateUserContextParams = {
  showType: {
    paramType: "string",
    validEnumValues: ["myForayApps", "forayApps", "default"],
    isMultiValue: false,
    storeParamName: "showTemplatesWithType",
    defaultValue: "myForayApps"
  },
  useFakeData: { paramType: "boolean", storeParamName: "debug_useFakeData" },
  filter: { paramType: "string" },
  MS: { paramType: "string" }
};
export {
  AnalysisTemplateUserContextParams
};
//# sourceMappingURL=AnalysisTemplateUserContextParams.js.map
